export const getUserIdsForKey = <
	T extends Record<string, unknown>,
	K extends keyof T,
>(
	source: T[] | null | undefined,
	key: K,
): Exclude<T[K], null | undefined>[] => {
	const ids = (source ?? [])
		.map((f) => f[key])
		.filter((f): f is Exclude<T[K], null | undefined> => f != null);

	return Array.from(new Set(ids));
};
